import _toConsumableArray from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
export var defaultNetworkState = {
  provider: undefined,
  chainId: undefined,
  accounts: [],
  errors: []
};
export function networksReducer(prevState, actions) {
  switch (actions.type) {
    case 'UPDATE_NETWORK':
      return Object.assign(Object.assign({}, prevState), actions.network);

    case 'ADD_ERROR':
      return Object.assign(Object.assign({}, prevState), {
        errors: [].concat(_toConsumableArray(prevState.errors), [actions.error])
      });

    default:
      return prevState;
  }
}